import React, { Component, PropTypes } from 'react';
import { Menu, Icon, Table, Button, Modal, Row, Col, Spin, Input, Form, Pagination } from 'antd';
import { browserHistory, Link } from 'react-router';
import _ from 'lodash';
import cn from 'classnames';
import { formItemLayout } from 'constants/layout';

import { connect } from 'react-redux';
import { TableHelper, exportAsExcel } from 'helpers/Table';
// import { getUsers, activeArticle, recommendArticle, unrecommendArticle, deleteArticle } from 'redux/modules/class';
import { getUsers, getAllUsers } from 'data/user';

import Utils from 'utils/utils';
import moment from 'moment';

import classes from '../styles/student/StudentList.module.scss';

import COLUMNS from './StudentListColumns';
// import { exportAsExcel } from 'helpers/Table';

const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;
const FormItem = Form.Item;
const pageLimit = 20;
const Confirm = Modal.confirm;

class StudentList extends Component {
  constructor(props) {
    super(props);
    this.onClickRow = this.onClickRow.bind(this);
    this.changeFocusPage = this.changeFocusPage.bind(this);
    this.onChangePage = this.onChangePage.bind(this);

    this.onSearch = this.onSearch.bind(this);
    this.onInputSearch = this.onInputSearch.bind(this);
    this.onSearchInputPress = this.onSearchInputPress.bind(this);
    this.onTableChange = this.onTableChange.bind(this);

    this.onAddNewPageContent = this.onAddNewPageContent.bind(this);
    this.state = {
      collapseMobile: [],
      showModal: false,
      page: props.page,
      displaySearchValue: '',
      searchBy: props.location.query.searchBy ? props.location.query.searchBy : 'all',
      searchValue: props.location.query.q ? props.location.query.q : '',
      sortBy: props.location.query.sortBy ? props.location.query.sortBy : undefined,
    };
  }

  componentDidMount = async () => {
    this.setState({
      loading: true,
    });
    const students = await getUsers(this.props.location.query);
    this.setState({
      loading: false,
      count: students.count,
      page: students.currentPage,
      students: students.results,
    });
  };

  componentWillMount() {
    this.setState({
      showModal: false,
    });
  }

  componentWillReceiveProps(props) {
    this.setState({
      searchBy: props.location.query.searchBy ? props.location.query.searchBy : 'all',
      searchValue: props.location.query.q ? props.location.query.q : '',
      sortBy: props.location.query.sortBy ? props.location.query.sortBy : undefined,
      page: props.location.query.page ? parseInt(props.location.query.page, 10) : 1,
    });
  }

  componentWillUnmount() {
    if (this.backListener) {
      this.backListener();
    }
  }

  onAddNewPageContent() {
    this.setState({
      showModal: true,
      selectedRow: {
        pageName: this.state.searchBy,
      },
      isAddNew: true,
    });
  }

  onClickRow(record, index) {
    console.log(record, index);
    // browserHistory.push(`/class/${record.slug}`);
  }

  onChangePage(page) {
    this.setState({
      page: page,
    });
    this.getUsers(_.merge(this.getCurrentQuery(), { page }));
  }

  onSearch() {
    this.setState({
      page: 1,
      searchValue: this.state.displaySearchValue,
    });
    this.getUsers(_.merge(this.getCurrentQuery(), { q: this.state.displaySearchValue, page: 1 })).then((response) => {
      console.log(response);
    });
  }

  onInputSearch(event) {
    this.setState({
      displaySearchValue: event.target.value,
    });
  }

  onSearchInputPress(event) {
    if (event.charCode === 13) {
      this.onSearch();
    }
  }
  onTableChange(a, b, sorter) {
    const { field, order } = sorter;
    if (order === 'descend') {
      this.setState({ sortBy: `-${field}` }, this.onSearch);
    } else if (order === 'ascend') {
      this.setState({ sortBy: field }, this.onSearch);
    }
  }

  getCurrentQuery() {
    return {
      page: this.state.page,
      searchBy: this.state.searchBy,
      q: this.state.searchValue,
      sortBy: this.state.sortBy,
    };
  }
  getUsers = async (query) => {
    browserHistory.push(`${this.props.location.pathname}${Utils.createQueryString(query)}`);
    this.setState({
      loading: true,
    });
    const students = await getUsers(query);
    this.setState({
      loading: false,
      count: students.count,
      page: students.currentPage,
      students: students.results,
    });
  };

  changeFocusPage(event) {
    const searchBy = event.key;
    this.setState({
      searchBy,
      page: 1,
    });
    this.getUsers(_.merge(this.getCurrentQuery(), { searchBy, page: 1 })).then((response) => {
      console.log(response);
    });
  }

  showDeleteConfirm(record, msg, content) {
    Confirm({
      title: msg,
      content: content || '',
      onOk: () => this.onDelete(record),
      onCancel: this.onCancel,
    });
  }

  exportToExcel() {
    getAllUsers(this.getCurrentQuery()).then((resultObj) => {
      const results = resultObj.results;
      const content = results.map((singleContent, key) => {
        singleContent.key = key;
        return singleContent;
      });
      const selectedStatusColumn = _.get(_.find(this.studentStatuses, { value: this.state.searchBy }), 'column');
      let columns = COLUMNS[selectedStatusColumn].map((colName) => {
        const col = _.find(this.columns, { dataIndex: colName });
        return col;
      });
      columns = _.compact(columns);
      exportAsExcel({
        filename: `STUDENTS-${moment().format('DD-MM-YYYY_HH-mm-ss')}.xlsx`,
        sheetName: 'Sheet1',
        columns,
        data: content,
      });
    });
  }

  columns = [
    {
      ...TableHelper.defaultColumn('No.', 'code'),
      render: (value, record) => (
        <div className="no-wrap">
          <Link to={`/student/${record._id}`}>{value} </Link>
          {record.remark && <Icon type="pushpin" />}
        </div>
      ),

      sorter: true,
    },
    {
      ...TableHelper.defaultColumn('Student name', 'name'),
      render: (value, record) => {
        const isVerified = _.get(record, 'verified');
        return (
          <span>
            <Link to={`/student/${record._id}`}>
              {`${value.first ? value.first : ''}  ${value.last ? value.last : ''}`} {isVerified && <Icon type="check-circle" className="text-primary" />}
            </Link>
          </span>
        );
      },
      renderExcel: (value, record) => `${record.name.first ? record.name.first : ''}  ${record.name.last ? record.name.last : ''}`,
    },
    {
      ...TableHelper.defaultColumn('Display Name', 'displayName'),
      sorter: true,
    },
    {
      ...TableHelper.defaultColumn('Email', 'email'),
    },
    {
      ...TableHelper.datetimeColumn('Register date', 'createdAt'),
      sorter: true,
    },
    {
      ...TableHelper.datetimeColumn('Verify date', 'verifiedDate'),
    },
    {
      ...TableHelper.datetimeColumn('Request date', 'requestedDate'),
      sorter: true,
    },
    {
      ...TableHelper.defaultColumn('Verified', 'verified'),
      render: (value) => {
        const element = value ? <Icon type="check" className="fa-2x text-success" /> : null;
        return element;
      },
    },
    {
      ...TableHelper.defaultColumn('Teacher status', 'isTeacher'),
      render: (value) => {
        const element = value ? <Icon type="check" className="fa-2x text-success" /> : null;
        return element;
      },
    },
    {
      ...TableHelper.integerColumn('Learned', 'studiedCount'),
      sorter: true,
    },
    {
      ...TableHelper.integerColumn('T-Points', 'points'),
      render: (value, record) => (
        <div className="no-wrap">
          <Link to={`/student/${record._id}?selectedTab=points`}>{value} </Link>
        </div>
      ),
      sorter: true,
    },
  ];

  studentStatuses = [
    { label: 'All Students', value: 'all', column: 'all' },
    { label: 'Verified', value: 'verified', column: 'verified' },
    { label: 'Non-verified', value: 'not_verified', column: 'rejected' },
    { label: 'Pending', value: 'pending', column: 'pending' },
    { label: 'Banned', value: 'deleted', column: 'deleted' },
  ];

  renderPageTopMenu() {
    return (
      <Menu onClick={this.changeFocusPage} selectedKeys={[this.state.searchBy]} mode="horizontal" className={classes.menu}>
        {this.studentStatuses &&
          this.studentStatuses.map((studentStatus) => (
            <Menu.Item key={studentStatus.value} className={classes.dashRight}>
              <div>{studentStatus.label} </div>
            </Menu.Item>
          ))}
      </Menu>
    );
  }

  renderContentTable() {
    const content = _.map(this.state.students, (singleContent, key) => {
      singleContent.key = key;
      return singleContent;
    });
    const selectedStatusColumn = _.get(_.find(this.studentStatuses, { value: this.state.searchBy }), 'column');
    let columns = COLUMNS[selectedStatusColumn].map((colName) => {
      const col = _.find(this.columns, { dataIndex: colName });
      return col;
    });
    columns = _.compact(columns);
    return (
      <div>
        <Table columns={columns} dataSource={content} bordered pagination={false} onRowClick={this.onClickRow} onChange={this.onTableChange} />
        <Pagination className={cn(classes.pagination, 'text-right')} current={this.state.page} onChange={this.onChangePage} defaultPageSize={pageLimit} total={this.state.count} />
      </div>
    );
  }

  render() {
    const { loading } = this.state;
    return (
      <div>
        <div className="page-header">
          <div>{this.props.BreadCrumb}</div>
        </div>
        <div className="content">
          <Spin tip="Loading" size="large" spinning={!!loading}>
            {this.renderPageTopMenu()}
            <div className={classes.searchContainer}>
              <Input prefix={<Icon type="search" />} placeholder="พิมพ์คำที่ต้องการค้นหา" onKeyPress={(e) => this.onSearchInputPress(e)} onChange={(e) => this.onInputSearch(e)} />
            </div>
            <div className="text-right">
              <a onClick={() => this.exportToExcel()}>
                <Icon type="file-excel" /> Export to excel
              </a>
            </div>
            {this.renderContentTable()}
          </Spin>
        </div>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    // pages: state.content.pages,
  }),
  {},
)(StudentList);
